import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/case-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from './react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { ICase } from 'src/types/case';
import CaseActionsColumn from './CaseActionsColumn';
import { CellProps } from 'react-table';
import CaseEnum from '../../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import { ISeance } from '../../../../../../../types/seance';
import dropDownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import OrderEnum from '../../../../../../../enumerables/order-enum';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import dateFilterMulti from '../../../../../../../components/react-table/filters/date-filter-multi';
import moment from 'moment';
import { IServiceType } from '../../../../../../../types/service-types';
import { IInvoice } from '../../../../../../../types/invoice';

interface Props {
    data: Paginated<ICase>;
    students: SelectObject[];
    districts: SelectObject[];
    serviceTypes: SelectObject[];
    providers: SelectObject[];
    vendors: SelectObject[];
    getData: (params: QueryParams) => void;
}

const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
const caseTypes: SelectObject[] = getValFromEnum(typeEnum);

const serviceTypeProviderEnum = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
const serviceTypeProviders: SelectObject[] = getValFromEnum(serviceTypeProviderEnum);

const CaseFilterStatus = CaseEnum ? CaseEnum.getEnum('CaseFilterStatus') : {};
const statusFilterValues: SelectObject[] = getValFromEnum(CaseFilterStatus);

const CaseStatus = CaseEnum ? CaseEnum.getEnum('CaseStatus') : {};

const statusValues: SelectObject[] = getValFromEnum(CaseStatus);

const typeOrderEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
const orderTypes: SelectObject[] = getValFromEnum(typeOrderEnum);

const completedFilterValues: SelectObject[] = [
    {
        label: 'Yes',
        value: 1,
    },
    {
        label: 'No',
        value: 2,
    },
];
const isBonusedFilterValues: SelectObject[] = [
    {
        label: 'Yes',
        value: true,
    },
    {
        label: 'No',
        value: false,
    },
];

const isSentViaPolarisFilterValues: SelectObject[] = [
    {
        label: 'Yes',
        value: '1',
    },
    {
        label: 'No',
        value: '0',
    },
];

const getColumns = (
    dataStud: SelectObject[],
    districts: SelectObject[],
    vendors: SelectObject[],
    providers: SelectObject[],
    serviceTypes: SelectObject[],
): Column<ICase>[] => [
    {
        Header: '#',
        accessor: 'id',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => <Link to={Router.generate(routes.CASE_EDIT, { id: original.id })}>{original.id}</Link>,
        Filter: textFilter<ICase>(),
        disableSortBy: true,
    },
    {
        Header: 'Case #',
        accessor: 'orderEntity.caseNumber',
        Filter: textFilter<ICase>(),
        disableSortBy: true,
    },
    {
        Header: () => (
            <div
                style={{
                    width: 100,
                    minWidth: 100,
                }}
            >
                Type
            </div>
        ),
        disableSortBy: true,
        accessor: 'caseType',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseType = caseTypes.find((it) => it.value === original.caseType);
            return valueCaseType ? valueCaseType.label : '';
        },
        Filter: dropdownFilter<ICase>(caseTypes),
    },
    {
        Header: 'Order Type',
        accessor: 'orderType',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueOrderType = orderTypes.find((it) => it.value === original.orderType);
            return valueOrderType ? valueOrderType.label : '';
        },
    },
    {
        Header: 'Student',
        accessor: 'student.id',
        disableSortBy: true,

        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) =>
            original.student ? `${original.student.firstName} ${original.student.lastName}` : null,
        Filter: dropDownFilter<ISeance>(dataStud, styles.minWidth),
    },
    {
        Header: 'Vendor',
        disableSortBy: true,
        accessor: 'vendor.id',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            if (!original?.vendor) return '';

            return (
                <Link
                    to={Router.generate(routes.VENDOR_DETAIL, {
                        id: original?.vendor?.id,
                    })}
                >
                    {`${original.vendor?.name}`}
                </Link>
            );
        },
        Filter: dropdownFilter<ICase>(vendors),
    },
    {
        Header: 'District',
        disableSortBy: true,
        accessor: 'district.id',

        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            if (!original?.district) return '';

            return (
                <Link
                    to={Router.generate(routes.DISTRICT_DETAIL, {
                        id: original?.district?.id,
                    })}
                >
                    {`${original.district?.name}`}
                </Link>
            );
        },
        Filter: dropdownFilter<ICase>(districts),
    },
    {
        Header: 'Order',
        disableSortBy: true,
        accessor: 'orderEntity.name',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => (original.orderEntity?.name ? `${original.orderEntity?.name}` : null),
        Filter: textFilter<ICase>(),
    },
    {
        Header: 'OrderId',
        disableSortBy: true,
        accessor: 'orderEntity.id',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) =>
            original.orderEntity?.id ? (
                <Link to={Router.generate(routes.ORDER_DETAIL, { id: original.orderEntity?.id })}>
                    {original.orderEntity?.id}
                </Link>
            ) : null,
        Filter: textFilter<ICase>(),
    },
    {
        Header: (
            <div
                style={{
                    width: 100,
                    minWidth: 100,
                }}
            >
                External Rate
            </div>
        ),
        disableSortBy: true,
        accessor: 'currentExternalRate',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => original.currentExternalRate,
        Filter: textFilter<ICase>(),
    },
    {
        Header: (
            <div
                style={{
                    width: 100,
                    minWidth: 100,
                }}
            >
                Internal Rate
            </div>
        ),
        disableSortBy: true,
        accessor: 'currentInternalRate',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => original.currentInternalRate,
        Filter: textFilter<ICase>(),
    },
    {
        Header: 'Provider',
        accessor: 'occasionProviders.provider',
        disableSortBy: true,

        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueProvider: string[] = [];
            original?.occasionProviders?.forEach((itP: any) => {
                if (itP.provider) {
                    valueProvider.push(`${itP.provider?.fullName}`);
                }
            });
            return valueProvider.join(', ');
        },

        Filter: dropdownFilter<ICase>(providers),
    },

    {
        Header: 'Service',
        accessor: 'serviceType.id',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            let title = original?.serviceType?.title;
            if (!title) {
                title = original?.serviceType?.cpt;
            }

            return <div>{title}</div>;
        },
        //Filter: textFilter<ICase>(),
        Filter: dropDownFilter<ICase>(serviceTypes, styles.minWidth),
    },

    {
        Header: () => (
            <div
                style={{
                    width: 100,
                    minWidth: 100,
                }}
            >
                Service Provider
            </div>
        ),
        disableSortBy: true,
        accessor: 'serviceTypeProvider',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueServiceTypeProvider = serviceTypeProviders.find(
                (it) => it.value === original.serviceTypeProvider,
            );
            return valueServiceTypeProvider ? valueServiceTypeProvider.label : '';
        },
        Filter: dropdownFilter<ICase>(serviceTypeProviders),
    },

    {
        Header: 'Location',
        accessor: 'serviceLocation',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueLocation: string[] = [];

            original.occasionServiceLocations.forEach((itP: any) => {
                valueLocation.push(
                    `${itP.serviceLocation?.title} -( from ${changeToZeroMoment(itP.createdAt, 'MMM D, YYYY')}`,
                );
            });
            return valueLocation.length ? valueLocation.shift() : null;
        },
        Filter: textFilter<ICase>(),
    },
    {
        Header: 'Datasheet',
        accessor: 'isDatasheetRequired',
        disableSortBy: true,
        // "Not required" is the value 0, and react-table's default (text) filter auto-removes any
        // falsy value — `equals` only drops the filter when it is actually unset.
        filter: 'equals',

        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const objReqs: { [key: number]: string } = {
                1: 'Required',
                0: 'Not required',
            };
            return objReqs[+!!original.isDatasheetRequired];
        },
        Filter: dropdownFilter<ICase>(
            [
                { value: 1, label: 'Required' },
                { value: 0, label: 'Not required' },
            ],
            styles.minWidth,
        ),
    },
    {
        Header: () => (
            <div
                style={{
                    width: 120,
                    minWidth: 120,
                }}
            >
                Status
            </div>
        ),
        accessor: 'status',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseStatus = statusValues.find((it) => it.value === original.status);
            return valueCaseStatus ? valueCaseStatus.label : '';
        },
        disableSortBy: true,
        Filter: dropdownFilter<ICase>(statusFilterValues, styles.minWidth),
    },
    {
        Header: 'Created',
        accessor: 'createdAt',
        disableSortBy: true,
        headerClassName: 'text-center w-100 d-block',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            return (
                <div className={'text-center'}>
                    {original.createdAt ? moment(original.createdAt).format('MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilterMulti<ICase>(),
    },
    {
        Header: () => (
            <div
                style={{
                    width: 120,
                    minWidth: 120,
                }}
            >
                Completed Eval
            </div>
        ),
        accessor: 'completed',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseCompleted = completedFilterValues.find((it) => {
                return it.value == original.completed;
            });
            return valueCaseCompleted ? valueCaseCompleted.label : '';
        },
        disableSortBy: true,
        Filter: dropdownFilter<ICase>(completedFilterValues, styles.minWidth),
    },

    {
        Header: () => (
            <div
                style={{
                    width: 120,
                    minWidth: 120,
                }}
            >
                Bonus
            </div>
        ),
        accessor: 'isBonused',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const value = isBonusedFilterValues.find((it) => {
                return it.value == original.isBonused;
            });
            return value ? value.label : '';
        },
        disableSortBy: true,
        Filter: dropdownFilter<ICase>(isBonusedFilterValues, styles.minWidth),
    },
    {
        Header: 'Has DOE email?',
        disableSortBy: true,
        accessor: 'doeEmail',
        Cell: ({
                   cell: {
                       row: { original },
                   },
               }: CellProps<ICase>) => {
            return original.doeEmail ? 'Yes' : 'No';
        },
        Filter: dropdownFilter<IInvoice>(isSentViaPolarisFilterValues, styles.minWidth),
    },
    {
        Header: () => (
            <div
                style={{
                    width: 100,
                    minWidth: 100,
                }}
            >
                Actions
            </div>
        ),
        accessor: 'note',
        Cell: CaseActionsColumn,
        disableSortBy: true,
        disableFilters: true,
    },
];

const CasesGrid: React.FunctionComponent<Props> = ({
    data,
    providers,
    getData,
    students,
    districts,
    vendors,
    serviceTypes,
}: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (students.length && !columns.length && providers.length) {
        setColumns(getColumns(students, districts, vendors, providers, serviceTypes));
    }
    const filtersInit: any[] = [];

    const match: any = useRouteMatch();
    const locationObject: any = useLocation();
    const query = new URLSearchParams(locationObject.search);

    if (query.get('status')) {
        match.params.status = query.get('status');
    }
    if (query.get('completed')) {
        match.params.completed = query.get('completed');
    }

    if (query.get('seanceActive')) {
        match.params.dateTo = moment().format('YYYY-MM-DD');
        match.params.dateFrom = moment().subtract(query.get('seanceActive'), 'days').format('YYYY-MM-DD');
    }

    useEffect(() => {
        if ((Object.values(match.params).length && match.params.status) || match.params.status) {
            Object.keys(match.params).forEach((k) => {
                filtersInit.push({ id: k, value: +match.params[k] });
            });
        }
        if ((Object.values(match.params).length && match.params.completed) || match.params.completed) {
            Object.keys(match.params).forEach((k) => {
                filtersInit.push({ id: k, value: +match.params[k] });
            });
        }
        if ((Object.values(match.params).length && match.params.dateFrom) || match.params.dateFrom) {
            Object.keys(match.params).forEach((k) => {
                filtersInit.push({ id: k, value: +match.params[k] });
            });
        }
        if ((Object.values(match.params).length && match.params.dateTo) || match.params.dateTo) {
            Object.keys(match.params).forEach((k) => {
                filtersInit.push({ id: k, value: +match.params[k] });
            });
        }
    }, []); // eslint-disable-line

    return (
        <div className={classNames(styles.grid)}>
            <Grid<ICase>
                filterGlobal={true}
                filtersInit={filtersInit}
                columns={columns}
                data={data}
                getData={getData}
            />
        </div>
    );
};

export default CasesGrid;
